import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { isMobile } from '../../../core/helpers/isMobile';
import GameBoard from '../../../components/common/gameBoard';

const GameBoardWrapper = observer(() => {
  const { containerConfig } = useMemo(() => {
    return {
      containerConfig: {
        x: isMobile() ? 270 : 717,
        y: isMobile() ? 406 : 389,
      },
    };
  }, []);

  return <GameBoard containerConfig={containerConfig} />;
});

export default GameBoardWrapper;
